<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiProductMallQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="商品列表查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId"  @change="changeFacilitator" style="width: 100%;" placeholder="请选择服务商" allowClear>
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>

					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">商品分类：</div>
						<a-select v-model="query.productCategoryId" style="width: 100%;" placeholder="请选择分类类型" allowClear>
							<a-select-option v-for="(item,index) in facilitatorCategoryList" :value="item.productCategoryId" :key="index">{{item.productCategoryName}}</a-select-option>
						</a-select>
					</div>
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title">商品名称：</div>
						<a-input v-model="query.name" style="width: 100%;" placeholder="请输入商品名称：" />
					</div>
				
				</div>
				<div class="qinang-search-row" style="margin-top: 10px;">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">商品状态：</div>
						<a-select v-model="query.productMallState" style="width: 100%;" placeholder="请选择商品状态" allowClear>
							<a-select-option v-for="(item,index) in statusList" :value="item.value" :key="index">{{item.label}}</a-select-option>
						</a-select>
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiProductMallQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						商品分类列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="productMallId" :loading="tableLoading" :pagination="false">

				<span slot="name" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.name}}</a-button>
				</span>
				<span slot="productCategoryId" slot-scope="productCategoryId">
					{{categoryList.find(item => item.productCategoryId == productCategoryId.productCategoryId)?.productCategoryName || ''}}
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{categoryList.find(item => item.facilitatorId == facilitatorId.facilitatorId)?.facilitatorName || ''}}
				</span>
				<span slot="productMallState" slot-scope="productMallState">
					{{statusList.find(item => item.value == productMallState.productMallState)?.label || ''}}
				</span>
				<span slot="isTop" slot-scope="isTop">
					{{isTop.isTop == 3?"是" : '否'}}
				</span>
				
                <span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>


		<!-- 添加弹窗 -->
		<a-drawer class="qa-modal" :bodyStyle="{padding: 0}" :title="addTitle" width="80%" :visible="addVisible"  @close="handleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<ProductMallForm v-if="addVisible" class="product-mall-form" @close="handleCancel"></ProductMallForm>
		</a-drawer>

		<!-- 修改弹窗 -->
		<a-drawer class="qa-modal" :bodyStyle="{padding: 0}" :title="editTitle" width="80%"  :visible="editVisible"  @close="handleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<ProductMallForm v-if="editVisible" class="product-mall-form" :id="productMallId" @close="handleCancel"></ProductMallForm>
		</a-drawer>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	import ProductMallForm from './components/productMallForm/index.vue'
	export default {
		components: {
			ProductMallForm,
		},
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//类型列表
				typeList: [
                     {
                        label:'景区',
                        value:1
                    },
                    {
                        label:'零售',
                        value:2
                    },
                    {
                        label:'餐饮',
                        value:3
                    },
                    {
                        label:'酒店',
                        value:4
                    },
                ],
				statusList: [
                    {
                        label:'上架',
                        value:3
                    },
                    {
                        label:'下架',
                        value:2
                    },
                ],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
					productCategoryId: undefined,
					productMallState: undefined,
					name: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'productMallId', key:'productMallId', align:'center'},
					{ title:'商品名称', key:'name', align:'center',scopedSlots:{customRender:'name'}},
					{ title:'商品分类', key:'productCategoryId', align:'center', scopedSlots:{customRender:'productCategoryId'}},
					{ title:'服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'排序', dataIndex:'sort', key:'sort', align:'center'},
					{ title:'销量', dataIndex:'salesCount', key:'salesCount', align:'center'},
					{ title:'商品状态', key:'productMallState', align:'center', scopedSlots:{customRender:'productMallState'}},
					{ title:'首页显示', key:'isTop', align:'center', scopedSlots:{customRender:'isTop'}},
					{ title:'添加时间', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}},
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addTitle: '添加',
				addConfirmLoading: false,
				// 添加弹窗-end
				// 修改弹窗-start
				editTitle: '修改',
				productMallId: undefined,
				editVisible: false,
				editConfirmLoading: false,
				// 修改弹窗-end
				categoryList: [],
				facilitatorList: [],
				facilitatorCategoryList:[],
          
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList(){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					// 确保checkstation始终是数组
					this.facilitatorList = Array.isArray(res.data) ? res.data : []
				} else {
					this.$message.error(res.msg)
				}
			},
			changeFacilitator(){
				this.query.productCategoryId = undefined
				this.facilitatorCategoryList = this.categoryList.filter(item => item.facilitatorId == this.query.facilitatorId)
				console.log(this.facilitatorCategoryList)
			},
			//获取分类列表
			async apiProductFacilitatorCategoryList() {
				try {
					const {
						data: res
					} = await this.$http.post(this.navigation.apiProductFacilitatorCategoryListForStaff,{staffId:window.sessionStorage.getItem('staffId')});
					if (res.code == 200) {
						// 确保checkstation始终是数组
						this.categoryList = Array.isArray(res.data) ? res.data : []
					} else {
						this.$message.error(res.msg)
						this.categoryList = []
					}
				} catch (error) {
					console.error('获取分类列表失败:', error)
					this.$message.error('获取分类列表失败')
					this.categoryList = []
				}
			},

			//--------------表格开始-搜索
			async apiProductMallQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductMallQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiProductMallQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiProductMallQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
			},



			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.productMallId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiProductMallDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			// 修改
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.productCategoryId == this.tableSelectedRows[0].productCategoryId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			edit(item){
				this.editTitle = '修改：[' + item.name + ']'
				console.log(item.productMallId)
				this.productMallId = item.productMallId
				this.editConfirmLoading = false
				// 先打开弹窗
				this.editVisible = true

			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false
			},

			//删除
			async apiProductMallDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductMallDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiProductMallQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
            this.apiProductMallQueryList()
			this.apiProductFacilitatorCategoryList()
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	.product-mall-form {
		width: 100%;
	}
	.qa-modal .ant-drawer-content-wrapper .ant-drawer-content .ant-drawer-wrapper-body .ant-drawer-body{
		padding: 0!important;	
	}

</style>
